import React, { createContext, useContext } from 'react'
import { SelectedValueReportingFacet } from '../../graphql/schema/types/value-reporting'
import { FilterManager, FilterManagerChildProps } from '../filter-manager'
import { VrApplicationAggregations } from './header/filters'
import { mapAggregationsToFacets } from './header/filters/map-aggregations-to-facets'

interface ValueReportingFiltersContextType<TAggregationCategory extends string>
  extends FilterManagerChildProps<TAggregationCategory> {
  selectedFacets: SelectedValueReportingFacet[]
}

const ValueReportingFiltersContext =
  createContext<ValueReportingFiltersContextType<VrApplicationAggregations> | null>(
    null
  )

export const ValueReportingFiltersProvider = ({ children }) => {
  return (
    <FilterManager filterType="applications">
      {(filterManagerProps) => (
        <ValueReportingFiltersContext.Provider
          value={{
            ...filterManagerProps,
            selectedFacets: mapAggregationsToFacets(
              filterManagerProps.aggregationSelections
            )
          }}
        >
          {children}
        </ValueReportingFiltersContext.Provider>
      )}
    </FilterManager>
  )
}

export const useValueReportingFilters = () => {
  const context = useContext(ValueReportingFiltersContext)
  if (!context) {
    throw new Error(
      `useValueReportingFilters must be wrapped by ValueReportingFiltersProvider`
    )
  }
  return context
}
